import { faBriefcase } from "@fortawesome/pro-solid-svg-icons/faBriefcase";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconInterestRequired: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faBriefcase} />;
};
